import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-gestionventecaisse',
  templateUrl: './gestionventecaisse.component.html',
  styleUrls: ['./gestionventecaisse.component.scss']
})
export class GestionventecaisseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
